// extracted by mini-css-extract-plugin
export default {"fotoSobreMim":"SobreMin_fotoSobreMim__2Sr78","subtitulo":"SobreMin_subtitulo__4FWMq","paragrafo":"SobreMin_paragrafo__qkx74"};